exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".inline-input {\r\n  width: 55%;\r\n}\r\n\r\n\r\n#map {\r\n  height: 500px;\r\n  width:100%;\r\n}\r\n.lavorazioneIncassoTooltip{\r\n  display: none;\r\n}\r\n.incassiInLavorazione:hover+.lavorazioneIncassoTooltip{\r\n  display: block;\r\n  position:absolute;\r\n  z-index:10;\r\n}\r\n.mobileExtended{\r\n  min-width: 800px;\r\n}\r\n@media(max-width:925px){\r\n  \r\n  #map {\r\n    width:auto;\r\n    width:initial;\r\n    margin-right:4em;\r\n  }\r\n}\r\n@media(max-width:767px){\r\n  .smartFontSize{\r\n    font-size:0.7em;\r\n  }\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/ETT/Progetti/JumpvNext/Angular/AgentiWebUI/AgentiWebConqordOil.Web.UI/src/app/components/clienti/cliente-detail.component.css
// module id = ../../../../../src/app/components/clienti/cliente-detail.component.css
// module chunks = main